var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar" },
    [
      _c(
        "div",
        { staticClass: "navbar-left" },
        [
          _c("hamburger", {
            staticClass: "hamburger-container",
            attrs: {
              "toggle-click": _vm.toggleSideBar,
              "is-active": _vm.sidebar.opened,
            },
          }),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("breadcrumb", { staticClass: "breadcrumb-container" }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "right-menu" },
        [
          _vm.device !== "mobile"
            ? [
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "全屏",
                      effect: "dark",
                      placement: "bottom",
                    },
                  },
                  [
                    _c("screenfull", {
                      staticClass: "right-menu-item hover-effect",
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "布局大小",
                      effect: "dark",
                      placement: "bottom",
                    },
                  },
                  [
                    _c("size-select", {
                      staticClass: "right-menu-item hover-effect",
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-dropdown",
            {
              staticClass: "avatar-container right-menu-item",
              attrs: { trigger: "click" },
            },
            [
              _c("div", { staticClass: "avatar-wrapper" }, [
                _c("img", {
                  staticClass: "user-avatar",
                  attrs: { src: _vm.headUrl },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "user-name" }, [_vm._v("管理员")]),
                _vm._v(" "),
                _c("i", { staticClass: "el-icon-arrow-down" }),
              ]),
              _vm._v(" "),
              _c(
                "el-dropdown-menu",
                {
                  staticClass: "user-dropdown",
                  attrs: { slot: "dropdown" },
                  slot: "dropdown",
                },
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/" } },
                    [
                      _c("el-dropdown-item", [
                        _c("i", { staticClass: "el-icon-s-home" }),
                        _vm._v("\n            首页\n          "),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-item",
                    {
                      attrs: { divided: "" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.handleUpdatePassword($event)
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-lock" }),
                      _vm._v("\n          密码修改\n        "),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-item",
                    {
                      attrs: { divided: "" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.logout($event)
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-switch-button" }),
                      _vm._v("\n          退出登录\n        "),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": true,
            title: "修改密码",
            visible: _vm.updatePasswordVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.updatePasswordVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "updateForm",
              attrs: {
                model: _vm.updateForm,
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "旧密码", prop: "oldPassword" } },
                [
                  _c("el-input", {
                    attrs: { "show-password": "", placeholder: "请输入旧密码" },
                    model: {
                      value: _vm.updateForm.oldPassword,
                      callback: function ($$v) {
                        _vm.$set(_vm.updateForm, "oldPassword", $$v)
                      },
                      expression: "updateForm.oldPassword",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "新密码", prop: "newPassword" } },
                [
                  _c("el-input", {
                    attrs: { "show-password": "", placeholder: "请输入新密码" },
                    model: {
                      value: _vm.updateForm.newPassword,
                      callback: function ($$v) {
                        _vm.$set(_vm.updateForm, "newPassword", $$v)
                      },
                      expression: "updateForm.newPassword",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "确认密码", prop: "newPasswordConfirm" } },
                [
                  _c("el-input", {
                    attrs: {
                      "show-password": "",
                      placeholder: "请再次输入新密码",
                    },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.confirmUpdatePassword($event)
                      },
                    },
                    model: {
                      value: _vm.updateForm.newPasswordConfirm,
                      callback: function ($$v) {
                        _vm.$set(_vm.updateForm, "newPasswordConfirm", $$v)
                      },
                      expression: "updateForm.newPasswordConfirm",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.updatePasswordVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmUpdatePassword },
                },
                [_vm._v("确认修改")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo-section" }, [
      _c("span", { staticClass: "logo-icon" }, [_vm._v("🏠")]),
      _vm._v(" "),
      _c("span", { staticClass: "logo-text" }, [_vm._v("家邻管理")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }